/**
 * Hyreskontrakt för garage / garageplats (Formulär R-13) — IR twin of the
 * legacy `garage@v1` template. Sections are §-numbered in order; the three
 * static clause blocks between "Särskilda bestämmelser" and "Underskrifter"
 * are unnumbered, as in the source.
 */
import { applyDefaults, COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
import { GARAGE_BLOCKS } from '../garage/blocks.js';
const TITLE = 'Hyreskontrakt för garage / garageplats';
const FORM_NUMBER = 'Formulär R-13';
const SLOTS = GARAGE_BLOCKS.flatMap((b) => b.slots);
const PREAMBLE = 'Mellan hyresvärd och hyresgäst har följande avtal om upplåtelse av garage eller garageplats ingåtts.';
export const garageV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: 'garage',
    documentVersion: 'v1',
    title: TITLE,
    locale: 'sv-SE',
    meta: {
        numberStyle: 'paragraph',
        category: 'Garage',
        shortTitle: 'Garagekontrakt',
        formNumber: FORM_NUMBER,
        preamble: PREAMBLE,
        description: 'Hyreskontrakt för helt garage eller garageplats (kall- eller varmgarage). Eget hyreskontrakt — inte kopplat till ett bostadsavtal.\n\n' +
            'Vem undertecknar: hyresvärden och hyresgästen via Scrive.\n\n' +
            'För enklare upplåtelse av mark som bilplats (öppet, utomhus) — använd istället mallen Bilplatsavtal.',
        status: 'active',
        signingMode: 'digital',
        signingPlacementAnchors: 'per-party-label',
        titleSuffix: { key: 'garage_place_number', prefix: 'plats' },
        partySlots: [
            { id: 'lessor', label: 'Hyresvärd', role: 'lessor', ordinal: 0, required: true, signs: true },
            { id: 'lessee', label: 'Hyresgäst', role: 'lessee', ordinal: 0, required: true, signs: true },
        ],
        propertySlots: [{ id: 'property', label: 'Fastighet', multi: false, required: true }],
    },
    values: applyDefaults({ fields: SLOTS }, values),
    blocks: [
        { instanceId: 'letterhead', blockRef: 'common.letterhead@v1', slot: 'letterhead', input: { title: TITLE, form_number: FORM_NUMBER } },
        { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: { form_number: FORM_NUMBER } },
        { instanceId: 'preamble', blockRef: 'common.preamble@v1', input: { text: PREAMBLE } },
        { instanceId: 'hyresvard', blockRef: 'garage.hyresvard@v1', input: {} },
        { instanceId: 'hyresgast', blockRef: 'garage.hyresgast@v1', input: { beside_previous: true } },
        { instanceId: 'garage', blockRef: 'garage.objekt@v1', input: {} },
        { instanceId: 'anvandning', blockRef: 'garage.anvandning@v1', input: {} },
        { instanceId: 'samnyttjande', blockRef: 'garage.samnyttjande@v1', input: {} },
        { instanceId: 'elstrom', blockRef: 'garage.elstrom@v1', input: {} },
        { instanceId: 'hyrestid', blockRef: 'garage.hyrestid@v1', input: {} },
        { instanceId: 'uppsagning', blockRef: 'garage.uppsagning@v1', input: {} },
        { instanceId: 'hyra', blockRef: 'garage.hyra@v1', input: {} },
        { instanceId: 'andring-hyra', blockRef: 'garage.andring-hyra@v1', input: {} },
        { instanceId: 'elkostnad', blockRef: 'garage.elkostnad@v1', input: {} },
        { instanceId: 'moms', blockRef: 'garage.moms@v1', input: {} },
        { instanceId: 'betalning', blockRef: 'garage.betalning@v1', input: {} },
        { instanceId: 'personuppgifter', blockRef: 'garage.personuppgifter@v1', input: {} },
        { instanceId: 'sarskilda-bestammelser', blockRef: 'garage.sarskilda-bestammelser@v1', input: {} },
        { instanceId: 'avtalsvillkor', blockRef: 'garage.avtalsvillkor@v1', input: {} },
        { instanceId: 'el-sarskilt', blockRef: 'garage.el-sarskilt@v1', input: {} },
        { instanceId: 'overlatelse', blockRef: 'garage.overlatelse@v1', input: {} },
        {
            instanceId: 'underskrift',
            blockRef: 'garage.underskrift@v1',
            input: {
                ref: 'underskrift',
                title: 'Underskrifter',
                statement: true,
                parties: [
                    { label: 'Hyresvärd', role: 'lessor', ordinal: 0 },
                    { label: 'Hyresgäst', role: 'lessee', ordinal: 0 },
                ],
            },
        },
    ],
});
//# sourceMappingURL=garage.js.map